"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Level = (function () {
    function Level(obj) {
        Object.assign(this, obj);
    }
    Level.prototype.starsForSolutionWithElementaryMovesLineMovesVariantsFound = function (e_moves, l_moves, _variantsCount) {
        var stars = [];
        stars.push('GM_STAR_TYPE_B');
        if (l_moves <= this.goalLineMoves) {
            stars.push('GM_STAR_TYPE_L');
        }
        if (e_moves <= this.goalElementaryMoves) {
            stars.push('GM_STAR_TYPE_E');
        }
        if (this.variantsCount == _variantsCount && _variantsCount > 1) {
            stars.push('GM_STAR_TYPE_V');
        }
        return stars;
    };
    return Level;
}());
exports.Level = Level;



//////////////////
// WEBPACK FOOTER
// ./src/interfaces/level.ts
// module id = 257
// module chunks = 0